<template>
    <div>
        <fa class="mr-2" :icon="['far', 'clock']"/>
        {{ timeString }}
    </div>
</template>
<script>
    import parse from "date-fns/parse";
    import format from "date-fns/format";
    import ru from 'date-fns/locale/ru'

    export default {
        name: 'HeaderTimer',
        props: {
            time: {
                type: String,
                required: true,
            },
            format: {
                default: 'dd.MM.yyyy HH:mm:ss',
            },
        },
        data () {
            return {
                initTime: 0,
                currentTime: 0,
            }
        },
        watch: {
            time () {
                this.updateInitTime();
            },
        },
        computed: {
            timeString () {
                const date = new Date(this.currentTime)
                const formatStr = this.format
                return format(date, formatStr, { locale: ru })
            },
        },
        mounted () {
            this.updateInitTime();
            this.updateTimer()
            setInterval(() => {
                this.updateTimer()
            }, 1000)
        },
        methods: {
            updateInitTime() {
                const time = parse(this.time, "yyyy-MM-dd HH:mm:ss", new Date()).getTime();
                this.initTime = time - this.getSeconds();
            },
            updateTimer () {
                this.currentTime = this.getSeconds() + this.initTime
            },
            getSeconds () {
                return (new Date()).getTime()
            },

        },
    }
</script>
